import { createContext, useContext } from 'react'

export type AdminLayoutContextValue = {
    sidebarOpen: boolean
    viewportWidth: number
}

export const AdminLayoutContext = createContext<AdminLayoutContextValue>({
    sidebarOpen: true,
    viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1200,
})

export const useAdminLayout = () => useContext(AdminLayoutContext)
